<template>
  <div class="dashboard-card">
    <v-card v-if="primaryContact" class="actual-card">
      <v-card-title>
        Your&nbsp;<span style="overflow-wrap: break-word">{{ contactTitle }}</span>
      </v-card-title>
      <v-card-text>
        <div class="text-center">
          <div>{{primaryContact.firstName}} {{primaryContact.lastName}}</div>
          <div>{{phoneNumber}}</div>
          <div>{{primaryContact.email}}</div>
          <div class="profile-pic-section">
            <v-img
                v-if="!profileImageFailure && primaryContact.profilePicture"
                :src="primaryContact.profilePicture"
                @error="contactImageError($event, primaryContact)"
            />
            <v-img v-else src="/profile-pics/default.svg"></v-img>
          </div>
        </div>

      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="goToCommunications">Contact Me</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import {formatPhoneForDisplay} from "@/components/forms/maska-masks";
import {COMMUNICATIONS} from "@/router/route-names";

export default {
  props: {
    profilePicture: {
      type: String,
      required: false,

    }
  },
  data: () => ({
    profileImageFailure: false,
  }),
  computed: {
    ...mapGetters({
      primaryContact: 'getActiveAccountPrimaryBrokerContact',
    }),
    phoneNumber() {
      if (this.primaryContact.publicPhone) {
        return formatPhoneForDisplay(this.primaryContact.publicPhone)
      }
      return undefined
    },
    contactTitle() {
      if (this.primaryContact == null) {
        return undefined
      }
      if (this.primaryContact.role === 'P_ACCT_MGR') {
        return 'Account Manager'
      }
      if (this.primaryContact.role === 'ACCT_MGR') {
        return 'Account Manager'
      }
      if (this.primaryContact.role === 'ADVISOR') {
        return 'Advisor'
      }
      return undefined
    },
    accountCode() {
      return this.$route.params.accountId
    },
  },
  methods: {
    goToCommunications() {
      this.$router
          .push({
            name: COMMUNICATIONS,
            params: { accountId: this.accountCode },
          })
          // eslint-disable-next-line no-unused-vars
          .catch(e => {})
    },
    contactImageError() {
      this.profileImageFailure = true
    },
  },
}
</script>
<style scoped lang="scss">
.profile-pic-section {
  max-width: 120px;
  max-height: 120px;
  margin-left: auto;
  margin-right: auto;
  .v-image {
    margin-top: 5px;
    max-width: 120px;
    max-height: 120px;
    border-radius: 50%;
  }
}
.dashboard-card {
  height: 100%;
}
.actual-card {
  &.v-card {
    height: 100%;
    min-height: 318px;
  }
  .v-card__actions {
    background-color: white;
    position: absolute;
    bottom: 0;
    width: 100%;
  }
}
</style>